import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

export default function DeleteTrainingModal({ show, onHide }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="delete-modal"
    >
      <Modal.Body className="text-center">
        {/* ICON */}
        <div className="icon-box">
          <FiTrash2 size={28} />
        </div>

        {/* TITLE */}
        <h4 className="title">Confirm Delete</h4>

        {/* TEXT */}
        <p className="desc">
          You want to delete all the marked items, this cant be
          undone once you delete.
        </p>

        {/* BUTTONS */}
        <div className="btn-group">
          <Button className="cancel-btn" onClick={onHide}>
            Cancel
          </Button>
          <Button className="delete-btn">
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>

      {/* STYLES */}
      <style>{`
        .delete-modal .modal-content {
          border-radius: 10px;
          padding: 20px 10px;
          border: none;
          background: #f9fafb;
        }

        .icon-box {
          width: 70px;
          height: 70px;
          margin: 0 auto 15px;
          background: #fde2e2;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ef4444;
        }

        .title {
          font-weight: 600;
          margin-bottom: 8px;
        }

        .desc {
          color: #6b7280;
          font-size: 14px;
          max-width: 320px;
          margin: 0 auto 20px;
        }

        .btn-group {
          display: flex;
          justify-content: center;
          gap: 10px;
        }

        .cancel-btn {
          background: #e5e7eb;
          border: none;
          color: #111827;
          padding: 8px 18px;
          border-radius: 6px;
        }

        .delete-btn {
          background: #ef4444;
          border: none;
          padding: 8px 18px;
          border-radius: 6px;
        }

        .delete-btn:hover {
          background: #dc2626;
        }

        /* MOBILE */
        @media (max-width: 576px) {
          .btn-group {
            flex-direction: column;
          }

          .btn-group button {
            width: 100%;
          }
        }
      `}</style>
    </Modal>
  );
}